module.exports = __webpack_public_path__ + "img/subpage-bg-2.16beb75f.jpg";